module.exports = __webpack_public_path__ + "static/media/ict2.98448854.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ict2.jpg
// module id = 5811
// module chunks = 0